import bem from 'utils/bem';

export const episodeTranscriptionModalBlock = bem(
  'episode-transcription-modal',
);
